import { createFileRoute } from "@tanstack/react-router";
import BcIdahoInsurance, { config } from "@/pages/BcIdahoInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/bc-idaho-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Blue Cross of Idaho TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Learn how Blue Cross of Idaho policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content:
            "Blue Cross of Idaho TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Learn how Blue Cross of Idaho policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/bc-idaho-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/bc-idaho-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <BcIdahoInsurance />;
}
